module.exports = __webpack_public_path__ + "static/media/LajanCash.22c795bf.png";